<a href (click)="onSort.emit({ field: field, order: order }); (false)">
  {{ label }}&nbsp;<span *ngIf="length">( {{ length }} )&nbsp;</span><span class="pi" [ngClass]="class"></span>
</a>
